import React from "react";
import { SsoProvider } from "@nrgpix/auth-sso";
import { ssoApi, commitSsoSignIn } from "./ssoApi";

export const SSO_CALLBACK_PATH = "/auth/sso/callback";

/** Plugs Sustina into the shared SSO package (api client, callback route, sign-in hand-off). */
export default function SustinaSsoProvider({ children }) {
    return (
        <SsoProvider api={ssoApi} callbackPath={SSO_CALLBACK_PATH} onSignedIn={commitSsoSignIn}>
            {children}
        </SsoProvider>
    );
}
